import React, {Component, Fragment} from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import { parse, isValid } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { productMapActions } from '../../actions'
import { fispqActions } from '../../actions'
import Header from "../../components/Header"
import Sidebar from "../../components/Sidebar"
import { Grid, Content } from '../../components/Layout'
import DataTable from '../../components/Table/Table'
import ContentHeader from '../../components/ContentHeader'
import { ProductMapModal } from '../../components/ProductModal'
import { pxToRem, color } from "../../utils"
import {
  DownloadButton,
  InputMaskDate,
  FormControl
} from "../../components/Form"
import Box from "../../components/Box"

const ProductMapLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const ExpiredDate = styled.p`
  color: red;
  font-weight: bold;
`

const ContentFilters = styled(Box)`
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  display: flex;
  padding: 20px;
  margin-bottom: ${pxToRem(35)};
  justify-content: space-between;
  align-items: flex-end;

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    padding: 20px;
  }
`

const WrapperFilter = styled.div`
  width: 100%;

  @media only screen and (max-width: 550px) {
    margin-bottom: ${pxToRem(18)};
  }
`

const Fields = styled.div`
  width: 95%;
  display: flex;
  margin-top: 10px;

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const FilterTitle = styled.p`
  width: 100%;
  margin: 0;
`

const ActionButton = styled(DownloadButton)`
  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const WrapperInputWithError = styled(FormControl)`
  padding: 0;
  width: 100%;
`

const InputError = styled.span`
  color: red;
  font-size: ${pxToRem(14)};
`

const columns = {
  id: {
    hide: true
  },
  expired: {
    hide: true
  },
  update_expired: {
    hide: true
  },
  name: {
    label: 'Produto',
    width: pxToRem(150),
    sortable: true
  },
  provider: {
    label: 'Fornecedor',
    width: pxToRem(150),
    sortable: true
  },
  fispq_issue_date: {
    label: 'Data de emissão FISPQ',
    width: pxToRem(150),
    sortable: true
  },
  fispq_update_date: {
    label: 'Data de atualização FISPQ',
    width: pxToRem(150),
    sortable: true
  }
}

class ControllerFispq extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openProductMapModal: false,
      filters: {
        issue: {},
        expiration: {}
      },
      errors: {
        issue: {},
        expiration: {}
      }
    }
  }

  componentDidMount() {
    this.props.fetchProductsFispq({})
  }

  closeProductModal = () => {
    this.setState(state => ({
      openProductMapModal: false
    }))
  }

  openProductModal = (e, id) => {
    e.preventDefault()
    this.props.fetchProductMap(id)

    this.setState(state => ({
      openProductMapModal: true
    }))
  }

  onChangeRowsPerPage = (rowsPerPage, currentPage = 1) => {
    const { issue, expiration } = this.state.filters
    const issue_initial_date = issue.initial_date
    const issue_final_date = issue.final_date
    const expiration_initial_date = expiration.initial_date
    const expiration_final_date = expiration.final_date

    this.props.fetchProductsFispq({
      page: currentPage,
      rowsPerPage,
      orderBy: this.props.pagination.order_by,
      order: this.props.pagination.order ? "asc" : "desc",
      issue_initial_date,
      issue_final_date,
      expiration_initial_date,
      expiration_final_date
    })
  }

  onChangePage = (newPage, rowsPerPage) => {
    const { issue, expiration } = this.state.filters
    const issue_initial_date = issue.initial_date
    const issue_final_date = issue.final_date
    const expiration_initial_date = expiration.initial_date
    const expiration_final_date = expiration.final_date

    this.props.fetchProductsFispq({
      page: newPage,
      rowsPerPage,
      orderBy: this.props.pagination.order_by,
      order: this.props.pagination.order ? "asc" : "desc",
      issue_initial_date,
      issue_final_date,
      expiration_initial_date,
      expiration_final_date
    })
  }

  onChangeOrderBy = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    const { issue, expiration } = this.state.filters
    const issue_initial_date = issue.initial_date
    const issue_final_date = issue.final_date
    const expiration_initial_date = expiration.initial_date
    const expiration_final_date = expiration.final_date

    this.props.fetchProductsFispq({
      page: currentPage,
      rowsPerPage,
      orderBy,
      order,
      issue_initial_date,
      issue_final_date,
      expiration_initial_date,
      expiration_final_date
    })
  }


  handleFilterDate = (scope, field, value) => {
    this.setState(state => ({
      ...state,
      errors: {
        ...state.errors,
        [scope]: { ...state.errors[scope], [field]: null }
      },
      filters: {
        ...state.filters,
        [scope]: { ...state.filters[scope], [field]: value }
      }
    }))
  }

  setErrorMessage = (scope, field, message) => {
    this.setState(state => ({
      ...state,
      errors: {
        ...state.errors,
      [scope]: { ...state.errors[scope], [field]: message}
      }
    }))
  }

  validFiltersDate = (scope, initial, final) => {
    if ( !initial ) return this.setErrorMessage(scope, 'initial_date', 'Obrigatório')
    if ( !final ) return this.setErrorMessage(scope, 'final_date', 'Obrigatório')

    let initialDateValid = false, finalDateValid = false

    if (initial) {
      initialDateValid = this.validDate(scope, 'initial_date', initial)
    }

    if ( final ) {
      finalDateValid = this.validDate(scope, 'final_date', final)
    }

    return initialDateValid && finalDateValid
  }

  validDate = (scope, field, date) => {
    const parsedDate = parse(date, 'dd/MM/yyyy', new Date(), { locale: ptBR })

    if (!isValid(parsedDate)) {
      this.setErrorMessage(scope, field, 'Data inválida')
      return false
    } else {
      this.setErrorMessage(scope, field, null)
      return true
    }
  }

  isInitialBeforeFinal = (scope, initial, final) => {
    const initialParsed = parse(initial, 'dd/MM/yyyy', new Date(), { locale: ptBR })
    const finalParsed = parse(final, 'dd/MM/yyyy', new Date(), { locale: ptBR })

    if (initialParsed > finalParsed) {
      this.setErrorMessage(scope, 'initial_date', 'Data inicial deve ser anterior à data final')
      return false
    } else {
      this.setErrorMessage(scope, 'initial_date', null)
      return true
    }
  }

  searchWithFilters = () => {
    const { filters } = this.state
    const { expiration, issue } = filters || {}
    let filtersParams

    if (issue.initial_date || issue.final_date) {
      const { initial_date, final_date } = issue || {}

      if (
        this.validFiltersDate('issue', initial_date, final_date) &&
        this.isInitialBeforeFinal('issue', initial_date, final_date)
      ) {
        filtersParams = {
          issue_initial_date: initial_date,
          issue_final_date: final_date
        }
      }
    }

    if (expiration.initial_date || expiration.final_date) {
      const { initial_date, final_date } = expiration || {}

      if (
        this.validFiltersDate('expiration', initial_date, final_date) &&
        this.isInitialBeforeFinal('expiration', initial_date, final_date)
      ) {
        filtersParams = {
          expiration_initial_date: initial_date,
          expiration_final_date: final_date
        }
      }
    }

    this.props.fetchProductsFispq({
      page: 1,
      rowsPerPage: this.props.pagination.rowsPerPage,
      orderBy: this.props.pagination.order_by,
      order: this.props.pagination.order ? "asc" : "desc",
      ...filtersParams
    })
  }

  render() {
    const {
      menuItems = [],
      router,
      last_update,
      loading,
      fispqList,
      pagination,
      fetch_errors,
      fetchProductsFispq
    } = this.props

    const {
      closeProductModal,
      openProductModal,
      onChangePage,
      onChangeRowsPerPage,
      onChangeOrderBy,
      handleFilterDate,
      searchWithFilters
    } = this

    const { openProductMapModal, filters, errors } = this.state

    const CellComponent = ({ name, value, row, ...rest }) => {
      return (
        <ProductMapLink {...rest} onClick={e => openProductModal(e, row.id)}>
          {value}
        </ProductMapLink>
      )
    }

    columns['name'] = {
      ...columns['name'],
      CellComponent
    }

    const ExpiringDateCellComponent = ({ name, value, row, ...rest }) => {
      if (row.expired && row.expired !== '---') {
        return (
          <ExpiredDate {...rest}>{value}</ExpiredDate>
        )
      }
      return <p {...rest}>{value}</p>
    }

    const UpdateDateCellComponent = ({ name, value, row, ...rest }) => {
      if (row.update_expired && row.update_expired !== '---') {
        return (
          <ExpiredDate {...rest}>{value}</ExpiredDate>
        )
      }
      return <p {...rest}>{value}</p>
    }

    columns['fispq_update_date'] = {
      ...columns['fispq_update_date'],
      CellComponent: UpdateDateCellComponent
    }

    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content>
            <ContentHeader
              title="Controle de FISPQ's"
              subtitle="Produtos com FISPQ registrado"
              last_update={last_update}
            />

            <ContentFilters>
              <WrapperFilter>
                <FilterTitle>Data de emissão</FilterTitle>
                <Fields>
                  <WrapperInputWithError>
                    <InputMaskDate
                      label={'Data Inicial'}
                      type={'text'}
                      value={filters.issue.initial_date || ''}
                      onChange={event => {
                        handleFilterDate('issue', 'initial_date', event.target.value)
                      }}
                      disabled={filters.expiration.initial_date || filters.expiration.final_date}
                    />
                    {errors.issue.initial_date && <InputError>{errors.issue.initial_date}</InputError>}
                  </WrapperInputWithError>
                  <WrapperInputWithError>
                    <InputMaskDate
                      label={'Data Final'}
                      type={'text'}
                      value={filters.issue.final_date || ''}
                      onChange={event => {
                        handleFilterDate('issue', 'final_date', event.target.value)
                      }}
                      disabled={filters.expiration.initial_date || filters.expiration.final_date}
                    />
                    {errors.issue.final_date && <InputError>{errors.issue.final_date}</InputError>}
                  </WrapperInputWithError>
                </Fields>
              </WrapperFilter>

              <WrapperFilter>
                <FilterTitle>Data de atualização</FilterTitle>
                  <Fields>
                    <WrapperInputWithError>
                      <InputMaskDate
                        label={'Data Inicial'}
                        type={'text'}
                        value={filters.expiration.initial_date || ''}
                        name="initial_date"
                        onChange={event => {
                          handleFilterDate('expiration', 'initial_date', event.target.value)
                        }}
                        disabled={filters.issue.initial_date || filters.issue.final_date}
                      />
                      {errors.expiration.initial_date && <InputError>{errors.expiration.initial_date}</InputError>}
                    </WrapperInputWithError>

                    <WrapperInputWithError>
                      <InputMaskDate
                        label={'Data Final'}
                        type={'text'}
                        value={filters.expiration.final_date || ''}
                        onChange={event => {
                          handleFilterDate('expiration', 'final_date', event.target.value)
                        }}
                        disabled={filters.issue.initial_date || filters.issue.final_date}
                      />
                      {errors.expiration.final_date && <InputError>{errors.expiration.final_date}</InputError>}
                    </WrapperInputWithError>
                </Fields>
              </WrapperFilter>

              <ActionButton
                  loading={loading}
                  onClick={
                    () => searchWithFilters()
                  }
                  disabled={
                    !filters.issue.initial_date &&
                    !filters.issue.final_date &&
                    !filters.expiration.initial_date &&
                    !filters.expiration.final_date
                  }
                >
                  Buscar
                </ActionButton>
            </ContentFilters>

            <DataTable
              loading={loading}
              error={fetch_errors.fispqList}
              fetchData={fetchProductsFispq}
              onChangePage={(newPage, rowsPerPage, orderBy, order) =>
                onChangePage(newPage, rowsPerPage, orderBy, order)
              }
              onChangeRowsPerPage={(rowsPerPage, currentPage, orderBy, order) =>
                onChangeRowsPerPage(rowsPerPage, currentPage, orderBy, order)
              }
              onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
              }
              columns={columns}
              height={'55vh'}
              width={1100}
              data={fispqList}
              pagination={pagination || {}}
              defaultSort={{ key: 'name', reverse: false }}
            />
          </Content>
        </Grid>

        <ProductMapModal
            open={openProductMapModal}
            closeModal={closeProductModal}
          />
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.fispqs.fetching.fispqList,
  pagination: state.fispqs.pagination,
  fispqList: state.fispqs.fispqList,
  total_records: state.fispqs.total_records,
  last_update: state.fispqs.last_update,
  total_records: state.fispqs.total_records,
  fetch_errors: state.fispqs.fetch_errors,
  areaId: state.auth.areaId,
  accessToken: state.headers.accessToken
})

const mapDispatchToProps = dispatch => {
  return {
    fetchProductsFispq: ({
        page,
        rowsPerPage,
        orderBy,
        order,
        issue_initial_date,
        issue_final_date,
        expiration_initial_date,
        expiration_final_date
    }) => {
      dispatch(fispqActions.fetchProductsFispq(
        page || 1,
        rowsPerPage || 10,
        orderBy || 'created_at',
        order || 'desc',
        issue_initial_date,
        issue_final_date,
        expiration_initial_date,
        expiration_final_date
      ))
    },
    fetchProductMap: id => {
      dispatch(productMapActions.fetchProductMap(id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControllerFispq)



// WEBPACK FOOTER //
// ./src/containers/ControllerFispq/ControllerFispq.js